import React, {useEffect, useState} from 'react'
import {AddIcon, AddIconOutline, MenuDots, SearchIcon} from "../../components/SvgIcons";
import {Col, Row, Form, Button, Dropdown, DropdownButton, InputGroup, FormControl} from "react-bootstrap"
import swal from "sweetalert";
import {useForm} from "react-hook-form";
import ThemeModal from "../../components/ThemeModal";
import {
    CreateSubCategory,
    DeleteSubCategory,
    GetSubCategories,
    UpdateSubCategory
} from "../../services/sub_categories.service";
import {toast} from "react-toastify";
import {constants, customStyles} from "../../utils/constants";
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {useHistory} from 'react-router-dom';

function SubCategoryList(props) {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState();
    const [keyword, setKeyword] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [category, setCategory] = useState(false);
    const [editModalData, setEditModalData] = useState(false);
    const {register, handleSubmit, reset, setValue, formState: {errors}} = useForm({
        mode: "onChange"
    });

    useEffect(async () => {
        await setCategory({
            id: props.match.params.category_id,
            name: props.location.state.category_name,
        });
        await getSubCategories(props.match.params.category_id);
    }, [page, perPage, keyword])

    useEffect(async () => {
        if (!modalShow && !editModalShow) {
            setEditModalData(false)
            reset();
        }
    }, [modalShow, editModalShow])

    const getSubCategories = async (category_id) => {
        setLoading(true)
        await GetSubCategories(category_id, page, perPage, keyword).then((result) => {
            if (result.status) {
                if (result.data.data) {
                    const rowData = [];
                    setPage(result.data.meta.current_page)
                    setTotalRows(result.data.meta.total);
                    result.data.data.map((dt, index) => {
                        console.log('dt===>', dt)
                        let nameAr = dt?.translations?.find(field => field.key === 'name' && field.locale === 'ar')?.message;
                        let nameCn = dt?.translations?.find(field => field.key === 'name' && field.locale === 'cn')?.message

                        rowData.push({
                            Id: dt.id,
                            Index: ++index,
                            SubCategoryName: dt.name,
                            SubCategoryNameAr: nameAr,
                            SubCategoryNameCn: nameCn
                        });
                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                return toast.error(result.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }

    const onSubCatDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete the selected Sub Category?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                await DeleteSubCategory(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getSubCategories(category.id)
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status == 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const subCatActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots/>}>
                <Dropdown.Item as="button" onClick={() => {
                    setEditModalShow(true)
                    setValue('Id', data.Id);
                    setValue('SubCategoryName', data.SubCategoryName);
                    setValue('SubCategoryNameAr', data?.SubCategoryNameAr);
                    setValue('SubCategoryNameCn', data?.SubCategoryNameCn);
                }}>
                    Edit
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onSubCatDelete(data.Id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }

    const statusCheck = (status) => {
        if (status === 10) {
            return <div className={"status-badge status-completed"}>Active</div>
        }
        if (status === 20) {
            return <div className={"status-badge status-cancelled"}>In Active</div>
        }
        return <div className={"status-badge status-undefined"}>Undefined</div>
    }

    const columns = [
        {
            id: 'SubCategoryName',
            name: 'Sub Category Name',
            selector: rowData => rowData.SubCategoryName,
        },
        {
            field: 'action',
            name: 'Action',
            cell: rowData => subCatActions(rowData),
        },
    ];

    const onModalSubmit = async data => {
        await CreateSubCategory({
            name: data.subCatName,
            category_id: category.id,
            name_ar: data?.subCatNameAr,
            name_cn: data?.subCatNameCn,
        }).then((data) => {
            if (data.status) {
                toast.success(data.message);
                getSubCategories(category.id);
                setModalShow(false)
                reset();
            } else {
                toast.error(data.message);
            }
        }).catch((error) => {
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    };

    const onEditModalSubmit = async data => {
        await UpdateSubCategory(data.Id, {
            name: data.SubCategoryName,
            category_id: category.id,
            name_ar: data?.SubCategoryNameAr,
            name_cn: data?.SubCategoryNameCn,
        }).then((data) => {
            if (data.status) {
                toast.success(data.message);
                getSubCategories(category.id);
                setEditModalShow(false)
                reset();
            } else {
                toast.error(data.message);
            }
        }).catch((error) => {
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    };

    /*
   *
   *  form elements inside popup
   *
   * */

    const ModalForm = () => {
        return (
            <div className={"modalBodyContent"}>
                <Form onSubmit={handleSubmit(onModalSubmit)}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Group className="mb-3" controlId="newSubCatName">
                                <Form.Label>Sub Category Name - EN<small style={{color: "red"}}>*</small></Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - EN"
                                    {...register('subCatName', {
                                        onChange: (e) => {
                                            setValue('subCatName', e.target.value)
                                        },
                                        required: {
                                            value: "required",
                                            message: "Sub Category Name is required"
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                                {errors.subCatName && <Form.Text
                                    className="text-muted validationText hasError">{errors.subCatName.message}</Form.Text>}
                                {/* AR */}
                                <Form.Label>Sub Category Name - AR</Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - AR"
                                    {...register('subCatNameAr', {
                                        onChange: (e) => {
                                            setValue('subCatNameAr', e.target.value)
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                                {/* CN */}
                                <Form.Label>Sub Category Name - CN</Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - CN"
                                    {...register('subCatNameCn', {
                                        onChange: (e) => {
                                            setValue('subCatNameCn', e.target.value)
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"} value={"Submit"}/>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    const EditModalForm = () => {
        return (
            <div className={"modalBodyContent"}>
                <Form onSubmit={handleSubmit(onEditModalSubmit)}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Group className="mb-3" controlId="newSubCatName">
                                <Form.Label>Sub Category Name</Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - EN"
                                    {...register('SubCategoryName', {
                                        onChange: (e) => {
                                            setValue('SubCategoryName', e.target.value)
                                        },
                                        required: {
                                            value: "required",
                                            message: "Sub Category Name is required"
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                                {errors.SubCategoryName && <Form.Text
                                    className="text-muted validationText hasError">{errors.SubCategoryName.message}</Form.Text>}
                                {/* AR */}
                                <Form.Label>Sub Category Name - AR</Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - AR"
                                    {...register('SubCategoryNameAr', {
                                        onChange: (e) => {
                                            setValue('SubCategoryNameAr', e.target.value)
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                                {/* CN */}
                                <Form.Label>Sub Category Name - CN</Form.Label>
                                <Form.Control
                                    placeholder="Sub Category Name - CN"
                                    {...register('SubCategoryNameCn', {
                                        onChange: (e) => {
                                            setValue('SubCategoryNameCn', e.target.value)
                                        },
                                        maxLength: {
                                            value: 255,
                                            message: "Max Length is 255"
                                        }
                                    })} type="text"
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"} value={"Submit"}/>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    return (
        <div className={"manageCategory"}>
            <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <h3 className="page-heading">Manage Sub Categories</h3>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <h3 className="page-heading text-themegreen text-end">{category.name}</h3>
                </Col>
            </Row>
            <hr/>
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon/></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onChange={(e) => {
                                    (e.target.value.length > 1) ? setKeyword(e.target.value) : setKeyword(null)
                                }}
                            />
                        </InputGroup>
                    </Col>

                    <Col xs={12} sm={12} md={7} lg={7} xl={7}>
                        <Row>
                            <Col xs={12} sm={12} md={3} lg={3} xl={3}></Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}></Col>
                            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                <Button className={"btn btn-green-theme h40 w-100"} onClick={() => setModalShow(true)}>
                                    <AddIconOutline/> Add New
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div className={"mt-3"}>
                <div className="theme-dataGrid products-dataGrid">
                    <DataTable
                        columns={columns}
                        data={rows}
                        progressPending={loading}
                        customStyles={customStyles}
                        selectableRows={false}
                        striped
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        onChangePage={(page) => {
                            setPage(page);
                        }}
                        onChangeRowsPerPage={(currentRowsPerPage) => {
                            setPerPage(currentRowsPerPage)
                        }}
                        progressComponent={<BarLoader color={'#12726C'} loading={loading} css={'marginTop: 10px'}
                                                      height={'4'} width={'100%'}/>}
                    />
                </div>
            </div>
            {/* Modal Form to add new product*/}
            <ThemeModal title={"Add New Sub Category"} size={"md"} content={<ModalForm/>} show={modalShow}
                        onHide={() => setModalShow(false)}/>
            <ThemeModal title={"Edit Sub Category"} size={"md"} content={<EditModalForm/>} show={editModalShow}
                        onHide={() => setEditModalShow(false)}/>
        </div>
    )
}

export default SubCategoryList
